<script>
	export let data;
	export let menuEntity;

	import { slide } from "svelte/transition";
</script>

{#if data}
	<div class="header" transition:slide>
		<div class="header__img">
			{#if data.Image}
				<img src={data.Image} alt="" />
			{:else if menuEntity == "clinic"}
				<img src={"/img/questionmark.svg"} alt="" class="blank" />
			{:else if menuEntity == "doctor"}
				<img src={"/img/user.svg"} alt="" class="blank" />
			{/if}
		</div>

		{#if data.url}
			<div style="display: flex;">
				{#if data.Name}
					<a class="header__name" href={data.url} target="_blank"
						>{data.Name}</a
					>
				{:else if data.NameFull}
					<a class="header__name" href={data.url} target="_blank"
						>{data.NameFull}</a
					>
				{:else}
					<a class="header__name" href={data.url} target="_blank"
						>Без названия</a
					>
				{/if}
			</div>
		{:else}
			<div style="display: flex;">
				{#if data.Name}
					<span class="header__name">{data.Name}</span>
				{:else if data.NameFull}
					<span class="header__name">{data.NameFull}</span>
				{:else}
					<span class="header__name">Без названия</span>
				{/if}
			</div>
		{/if}

		{#if data.PremodStatus}
			<span class="header__adress">На модерации</span>
		{/if}

		{#if data.Adress}
			<span class="header__adress">{data.Adress}</span>
		{/if}
	</div>
{/if}

<style lang="scss">
	.header {
		max-width: 280px;
		padding: 16px 24px;
		display: flex;
		flex-direction: column;
		&__img {
			display: flex;
			height: 80px;
			width: 80px;
			> img {
				object-fit: cover;
				height: 100%;
				width: 100%;
				border-radius: 8px;
				&.blank {
					padding: 15px;
					background: var(--bg-main-1);
				}
			}
		}
		&__name {
			font-size: 16px;
			margin-top: 12px;
			color: var(--text-main-1);
			font-weight: bold;
			word-break: break-all;
		}
		&__adress {
			font-size: 13px;
			color: var(--text-main-1);
			margin-top: 6px;
			word-break: break-all;
		}
	}
	a.header__name {
		text-decoration: underline;
	}
</style>
